import React from 'react';
import PropTypes from 'prop-types';
import Notification from 'erpcore/components/Notification';

/**
 * Notification Manager - Activity Challenges Notifications
 * @return {Node} Returns Notification component
 */
// eslint-disable-next-line no-unused-vars
const ActivityTypesNotifications = ({ identifier, code, detail, notificationData }) => {
    switch (code) {
        case 'activitytype.itemSuccessfulyRemoved':
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Template type successfully deleted!"
                    type="success"
                    expire="3500"
                />
            );
        case 'activitytype.itemSuccessfulyUpdated':
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Template type successfully updated!"
                    type="success"
                    expire="3500"
                />
            );
        case 'activitytype.itemSuccessfulyCreated':
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Template type successfully created!"
                    type="success"
                    expire="3500"
                />
            );

        default:
            return null;
    }
};

ActivityTypesNotifications.defaultProps = {
    identifier: null,
    code: null,
    detail: null,
    notificationData: null
};

ActivityTypesNotifications.propTypes = {
    identifier: PropTypes.string,
    code: PropTypes.string,
    detail: PropTypes.string,
    notificationData: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array])
};

export default ActivityTypesNotifications;
